export default "__VITE_ASSET__DIxdBzMu__"